exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tr-whole-border th{padding:12px 6px}.many-field-tr td{padding:6px}.progress-btn{border-radius:3px;display:inline-block;width:84px;padding:6px 0;margin:2px;font-weight:700;font-size:.8rem}.btn-confirm-new-req{background-color:#ffb100;color:#fff}.btn-stand-by-ests{color:#064160;font-weight:700}.btn-write-sheet{background-color:$primary;color:#fff}.bid-state{margin:2px 0;color:#fff;border-radius:3px;display:inline-block;width:76px;padding:4px}.bid-state-ing{background-color:#1c7cd5}.bid-state-ok{background-color:#5cb85c}.bid-state-no{background-color:#f0ad4e}", ""]);

// exports
